import BasicModal from './BasicModal';

const ConfirmationModal = ({
  onHide,
  onConfirm,
  heading,
  buttonText,
  children,
  ...others
}) => {
  return (
    <BasicModal
      buttonText={buttonText}
      heading={heading}
      onConfirm={onConfirm}
      onHide={onHide}
      typeOfContent="text"
      {...others}
    >
      {children}
    </BasicModal>
  );
};

export default ConfirmationModal;
